export const DBaseInteractive = wcardinal.ui.DBaseInteractive;